import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultFilmAdvanceBookingPeriodNotificationDisplayText = {
    messageFormat: 'Tickets on sale at select cinemas from ${startsAt|d|Do of MMMM, h:mm A}.',
    todayMessageFormat: 'Tickets on sale at select cinemas today from ${startsAt|d|h:mm A}.'
};
export const filmAdvanceBookingPeriodNotificationDisplayTextValidatorSchema = {
    messageFormat: nonEmptyStringValidator,
    todayMessageFormat: nonEmptyStringValidator
};
export const filmAdvanceBookingPeriodNotificationDisplayTextValidator = Validator.object(filmAdvanceBookingPeriodNotificationDisplayTextValidatorSchema);
